import { connect } from 'react-redux';

import * as selectors from '../../accountsSelector';

import FutureRepayments from '../../dashboardComponents/futureRepayment/FutureRepayments';
import PastRepayments from '../../dashboardComponents/pastRepayments/PastRepayments';
import dashboardCtaStyles from '../../dashboardComponents/DashboardCTA/DashboardCTA.module.css';
import { RootState } from '@iwProvider/configureStore';
import {
    DashboardActionTypes,
    TOP_UP_DRAWDOWN_ACTION
} from '../../../sharedDashboardComponents/LoanProgressBar/DashboardActions.types';
import TopUpApproved from './TopUpApproved/TopUpApproved';
import RepayEarlyForFree from './RepayEarlyForFree/RepayEarlyForFree';
import NotYetTopUpEligible from './NotYetTopUpEligible/NotYetTopUpEligible';
import TopUpPending from './TopUpPending/TopUpPending';
import TopUpEligible from './TopUpEligible/TopUpEligible';
import { getTopUpStatus } from '../../NewOutstandingView/NewOutstandingView.helpers';
import { tracking } from '@iwoca/frontend-tracking-library';
import InterestOnlyExtension from './InterestOnlyExtension/InterestOnlyExtension';

const mapStateToProps = (state: RootState) => {
    const productType = selectors.getProductTypeFromURL();

    return {
        topUpStatus: getTopUpStatus(state, productType)
    };
};

type TProps = {
    accountId: string;
    setActiveDashboardAction: (action: DashboardActionTypes) => void;
} & ReturnType<typeof mapStateToProps>;

const DashboardActions = ({
    topUpStatus,
    setActiveDashboardAction,
    accountId
}: TProps) => {
    return (
        <div>
            <TopUpActions
                accountId={accountId}
                topUpStatus={topUpStatus}
                setActiveDashboardAction={setActiveDashboardAction}
            />

            <RepayEarlyForFree
                className={dashboardCtaStyles.nonBottomDashboardAction}
            />

            <FutureRepayments
                className={dashboardCtaStyles.nonBottomDashboardAction}
                accountId={accountId}
            />

            <PastRepayments accountId={accountId} />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(DashboardActions);

const TopUpActions = ({ topUpStatus, setActiveDashboardAction }: TProps) => {
    const showDrawdownPanel = () => {
        tracking.ampli.drawdownCtaClicked();
        setActiveDashboardAction(TOP_UP_DRAWDOWN_ACTION);
    };

    switch (topUpStatus) {
        case 'NOT_YET_TOPUP_ELIGIBLE':
            return <NotYetTopUpEligible />;
        case 'TOPUP_PENDING':
            return <TopUpPending />;
        case 'PRE_APPROVED':
            return (
                <>
                    <TopUpApproved
                        onCtaClick={showDrawdownPanel}
                        className={dashboardCtaStyles.nonBottomDashboardAction}
                    />
                    <TopUpEligible
                        className={dashboardCtaStyles.nonBottomDashboardAction}
                    />
                </>
            );
        case 'INTEREST_ONLY_EXTENSION_APPROVED':
            return (
                <InterestOnlyExtension
                    onCtaClick={showDrawdownPanel}
                    className={dashboardCtaStyles.nonBottomDashboardAction}
                />
            );
        default:
            return null;
    }
};
